import React from "react";
import HeadlineWithFocus from "../components/HeadlineWithFocus";
import Helmet from "react-helmet";

export default () => (
  <div className="c-content-box">
    <Helmet title="Let's play" />

    <HeadlineWithFocus>
      About Me
      {/* <span>What's that?</span> */}
    </HeadlineWithFocus>
    {/* <p>Coming soon...</p> */}
    <p>
      I enjoy coding because I can see how little things make a big differences in coding. I first got into software engineering because of high school.
      </p>
      {/* <br/> */}
      <p>
      I have been in Prime Digital Academy for the past 4 months and I have learn the full stack development. It was hard to start from nothing and do a big change of career change.
      </p>
      {/* <br/> */}
      <p>
      One of my hobbies outside of work is cars. Just anything to do with them, like example racing, and talking about the new and old cars or fixing them.
      </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/playground.jsx